module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhiqcOSmcOSuaOCyaODOVNjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABYALAAAAAAgACAAAAXGoCWOZGmeaFmtVeqi7Ri/dCUI4j3T8O37Ox7J9isGhcSiUShT6liCFTNZhEgkq+gKwHW1nAqWwVZ5bF8xQWHAhrAYBt+Chc4V1u5Vo1FM0FNfQHkIB04sR0M/FBQVCAhOT1KAQBURE5A+WJI9WhGYin+cn5iIMlCjTzpeKxKoh6qAFRAOnysRDkSbJgAruJAsEVSlFlyvRhOnQCkAIsA/h1SwaJUQkVlLSFnQSsMwZMnKTE1a3OIqv+Ym0VHpJ9fs7e6h8ekhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNW_S1.gif
// module id = MwDL
// module chunks = 50